import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { PurpleArrowLeft } from 'Images';
import { isDesktop } from 'react-device-detect';

export interface ITreatmentCard {
  label: string;
  icon: string;
  callback: () => void;
}

export const TreatmentCard = ({ label, icon, callback }: ITreatmentCard) => {
  return isDesktop ? (
    <Stack
      flexDirection={'row'}
      onClick={callback}
      sx={{
        backgroundColor: '#fff',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '8px',
        boxShadow: '0px 1px 20px 0px #081E541A',
        cursor: 'pointer',
        p: '24px 16px',
        justifyContent: 'space-between',
        height: '111px',
        maxWidth: '350px',
      }}
    >
      <Stack flexDirection={'row'} alignItems={'center'}>
        <Avatar src={icon} sx={{ width: '40px', height: '40px' }} alt='' />
        <Typography
          component={'h2'}
          sx={{ flexGrow: 1, ml: 1, display: 'flex', alignItems: 'center' }}
        >
          {label}
        </Typography>
      </Stack>

      <Button
        endIcon={
          <Avatar
            alt=''
            src={PurpleArrowLeft}
            sx={{ width: '20px', height: '20px' }}
          />
        }
        sx={{
          minWidth: '20px !important',
        }}
      ></Button>
    </Stack>
  ) : (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
      <Stack
        flexDirection={'row'}
        onClick={callback}
        sx={{
          backgroundColor: '#fff',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          borderRadius: '12px',
          boxShadow: '0px 1px 20px 0px #081E541A',
          cursor: 'pointer',
          width: 'calc(100% - 25px)',
          height: '72px',
          position: 'relative',
          alignItems: 'center',
          pl: '40px',
        }}
      >
        <Box
          sx={{
            width: '70px',
            height: '70px',
            border: '2px solid',
            borderColor: 'primary.shade_200',
            borderRadius: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            left: '-30px',
            backgroundColor: '#fff',
          }}
        >
          <Avatar
            src={icon}
            sx={{
              width: '40px',
              height: '40px',
            }}
            alt=''
          />
        </Box>
        <Typography component={'h2'} sx={{ flexGrow: 1, ml: 2 }}>
          {label}
        </Typography>
        <Button
          endIcon={
            <Avatar
              alt=''
              src={decodeURIComponent(PurpleArrowLeft)}
              sx={{ width: '20px', height: '20px' }}
            />
          }
        />
      </Stack>
    </Box>
  );
};
